import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/global-state';
import { IncentiveEvaluationErrorCodes } from 'state/loyalty/hooks/types';
import { LoyaltyOffer } from 'state/loyalty/types';

import { incentiveErrorsFilteredList } from './offers.utils';

export const selectAppliedOffers = ({ loyalty }: RootState) => {
  return loyalty.offers.appliedOffers;
};

export const selectCartEntriesIdsMap = ({ loyalty }: RootState) => {
  return loyalty.offers.cartEntriesIdsMap;
};

export const selectOfferFeedbackMap = ({ loyalty }: RootState) => {
  return loyalty.offers.offersFeedbackMap;
};

export const selectOffersLoading = ({ loyalty }: RootState) => {
  return loyalty.offers.offersLoading;
};

export const selectOffers = ({ loyalty }: RootState) => {
  return loyalty.offers.offers;
};

export const selectUserOffers = ({ loyalty }: RootState) => {
  return loyalty.offers.userOffers;
};

export const selectPersonalizedOffers = ({ loyalty }: RootState) => {
  return loyalty.offers.personalizedOffers;
};

export const selectSurpriseAvailable = ({ loyalty }: RootState) => {
  return loyalty.offers.surpriseAvailable;
};

export const selectUpsizeAvailable = ({ loyalty }: RootState) => {
  return loyalty.offers.upsizeAvailable;
};

export const selectSelectedOffer = ({ loyalty }: RootState) => {
  return loyalty.offers.selectedOffer;
};

export const selectIncentiveErrorsFilteredByCode = (
  { loyalty }: RootState,
  errorCodeToFilter: IncentiveEvaluationErrorCodes
) => {
  return incentiveErrorsFilteredList(
    loyalty.offers.offersFeedbackMap,
    evaluationError => evaluationError.code !== errorCodeToFilter
  );
};

export const selectIncentiveErrorsWithCode = (
  { loyalty }: RootState,
  errorCodeToFilter: IncentiveEvaluationErrorCodes
) => {
  return incentiveErrorsFilteredList(
    loyalty.offers.offersFeedbackMap,
    evaluationError => evaluationError.code === errorCodeToFilter
  );
};

export const selectCmsOffers = ({ loyalty }: RootState) => {
  return loyalty.offers.cmsOffers;
};

export const selectCmsOffersMapByLoyaltyId = ({
  loyalty,
}: RootState): { [key: string]: LoyaltyOffer } => {
  return (loyalty.offers.cmsOffers || []).reduce((acc, offer) => {
    if (offer?.loyaltyEngineId) {
      acc[offer.loyaltyEngineId] = offer;
    }

    return acc;
  }, {});
};

export const selectAppliedCmsOffers = ({ loyalty }: RootState) => {
  const set = new Set(loyalty.offers.appliedOffers.map(({ id }) => id));
  return loyalty.offers.cmsOffers?.filter(cmsOffer => set.has(cmsOffer.loyaltyEngineId));
};

export const selectDiscountAppliedCmsOffers = createSelector(
  selectAppliedCmsOffers,
  appliedCmsOffers =>
    appliedCmsOffers?.filter(cmsOffer => cmsOffer.incentives?.[0]?.__typename === 'OfferDiscount')
);
